import { Text } from '$components'
import { LinkButton } from '$components'

export function NotFound() {
  return (
    <div className="flex flex-col items-center justify-center px-stack-roomy py-stack-hero text-center">
      <Text
        type="h1"
        className="font-semibold text-9xl mb-stack text-fg-link"
      >
        404
      </Text>

      <Text
        type="h2"
        className="text-3xl mt-stack-roomy"
      >
        Sorry! Page not found
      </Text>

      <Text
        type="p"
        className="max-w-prose-lg mt-stack-roomy mb-stack-grid font-light"
      >
        It looks like the page you&apos;re looking for doesn&apos;t exist or might have been moved. Let&apos;s get you back on track.
      </Text>

      <LinkButton
        size="lg"
        to="/"
      >
        Back to home
      </LinkButton>
    </div>
  )
}
